export default {
    newPageCreateFile: "Creando archivo",
    globalConfirm: "OK",
    globalCancel: "Cancelar",
    globalStyle: "Estilo",
    globalColor: "Color",
    globalLine: "Línea",
};
